import { PageSection } from '../../Layout';
import { BalanceEquipmentSection } from '../Balances';
import { DriverInterfacingSection } from '../Driver';

const BalanceEquipment = () => {
  return (
    <PageSection>
      <BalanceEquipmentSection />
      <DriverInterfacingSection />
    </PageSection>
  );
};

export default BalanceEquipment;
export { BalanceEquipment };
